<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'MultipleHistograms',
  extends: Bar,
  mixins: [reactiveProp],

  props: {
    chartData: { required: true, type: Object },
    options: { required: true, type: Object },
    chartId: { default: 'multiple-scores-chart', type: String }
  },
  mounted () {
    this.renderThat()
  },

  methods: {
    renderThat () {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/reports/charts/MultipleHistograms.vue